<template>
  <div class="flex-col h-100">
    <div class="flex-col panle-content">
      <div class="title"> {{ $t("filter") }}</div>
      <div class="flex-col search-type"
        v-if="type == orgType">
        <search-type-bar :search-type="orgStage"
          ref='orgStage'></search-type-bar>
        <search-type-bar :search-type="orgIndustry"
          ref='orgIndustry'></search-type-bar>
      </div>
      <div class="flex-col search-type"
        v-if="type == companyType">
        <search-type-bar :search-type="companyIndustry"
          ref='companyIndustry'></search-type-bar>
        <search-type-bar :search-type="companyRound"
          ref='companyRound'></search-type-bar>
        <search-type-bar :search-type="companyInvestmentDate"
          ref='companyInvestmentDate'></search-type-bar>
      </div>
      <div class="flex-col search-type"
        v-if="type == orgInvestedCompany">
        <search-type-bar :search-type="companyIndustry"
          ref='companyIndustryByOrgInvestedCompany'></search-type-bar>
      </div>
      <div class="flex-col search-type"
        v-if="type == contactType">
        <search-type-bar :search-type="relationDeepth"
          ref='relationDeepth'></search-type-bar>
        <search-type-bar :search-type="title"
          v-show="false"
          ref='title'></search-type-bar>
        <search-type-bar :search-type="userIndustry"
          ref='userIndustry'></search-type-bar>
      </div>
      <div class="flex-col search-type"
        v-if="type == contactCompanyType">
        <search-type-bar :search-type="relationDeepth"
          ref='relationCompanyDeepth'></search-type-bar>
      </div>
      <div class="flex-col search-type"
        v-if="type == newsType">
        <search-type-bar :search-type="newsTypeName"
          ref='news'></search-type-bar>

        <search-type-bar :search-type="marketTypeName"
          ref='newsPeriod'></search-type-bar>
      </div>
      <div class="flex-col search-type"
        v-if="type == marketType">
        <search-type-bar :search-type="marketTypeName"
          ref='marketNews'></search-type-bar>
      </div>
      <!-- IPO -->
      <div class="flex-col search-type"
        v-if="type == exitIPO">
        <search-type-bar :search-type="orgIndustry"
          title="行业领域"
          ref='orgIndustryIPO'></search-type-bar>
      </div>
      <div class="flex-col search-type"
        v-if="type == exitIPO2">

        <search-type-bar :search-type="stockExchange"
          ref='stockExchange'></search-type-bar>
      </div>
      <div class="flex-col search-type"
        v-if="type == exitSales">
        <search-type-bar :search-type="orgIndustry"
          title="行业领域"
          ref='orgIndustrySales'></search-type-bar>

      </div>

      <div class="flex-col search-type"
        v-if="type == orgListFunding1">
        <search-type-bar :search-type="dates"
          ref='fund_dates'
          title="投资时间"></search-type-bar>

      </div>
      <div class="flex-col search-type"
        v-if="type == orgListFunding2">
        <search-type-bar :search-type="orgIndustry"
          ref='fund_orgIndustry'
          title="所在领域"></search-type-bar>

      </div>
      <div class="flex-col search-type"
        v-if="type == orgListFunding3">
        <search-type-bar :search-type="companyRound"
          ref='fund_orgStage'
          title="投资阶段"></search-type-bar>
      </div>
      <div class="flex-col search-type"
        v-if="type == onlyDates">
        <search-type-bar :search-type="dates"
          ref='onlyDates'></search-type-bar>
      </div>
    </div>
    <div class="flex-row">
      <van-button class="reset-button"
        native-type="button"
        @click="reset">
        {{ $t('common.reset') }}
      </van-button>
      <van-button class="ok-button"
        type="primary"
        native-type="button"
        @click="search()">
        {{ $t('common.filter') }}
      </van-button>
    </div>
  </div>
</template>

<script> 
import _ from "lodash";
import common from "../../common/common";
import storejs from "@common/store.js";
import userInfo from "../../common/loginInfo";
import eventHub from "@/common/EventHub";
import SearchTypeBar from "../../components/common/SearchTypeBar.vue";
export default {
  name: "SearchPanel",
  props: ["type"],
  components: {
    SearchTypeBar,
  },
  data () {
    return {
      isPanel: false,
      title: "title",
      dates: "dates",
      relationDeepth: "relationDeepth",
      orgStage: "orgStage",
      stockExchange: "stockExchange",
      orgIndustry: "orgIndustry",
      companyIndustry: "orgIndustry",
      companyRound: "companyRound",
      companyInvestmentDate: "companyInvestmentDate",
      newsTypeName: "newsType",
      marketTypeName: "marketPeriod",
      userIndustry: "userIndustry",
      userId: userInfo.userToken.userId,
      orgType: common.searchTypeEnum.org,
      companyType: common.searchTypeEnum.invested,
      contactType: common.searchTypeEnum.contractor,
      contactCompanyType: common.searchTypeEnum.contractorCompany,
      newsType: common.searchTypeEnum.newsType,
      marketType: common.searchTypeEnum.marketPeriod,
      exitIPO: common.searchTypeEnum.exitIPO,
      exitIPO2: common.searchTypeEnum.exitIPO2,
      exitSales: common.searchTypeEnum.exitSales,
      orgInvestedCompany: common.searchTypeEnum.orgInvestedCompany,
      orgListFunding1: common.searchTypeEnum.orgListFunding1,
      orgListFunding2: common.searchTypeEnum.orgListFunding2,
      orgListFunding3: common.searchTypeEnum.orgListFunding3,
      onlyDates: common.searchTypeEnum.onlyDates,
    };
  },
  created () {
    this.titleName = "common." + this.type;
    debugger;
  },
  methods: {
    search (isReset) {
      let searchParams = {};
      //查询-机构
      if (this.type == common.searchTypeEnum.org) {
        searchParams = {
          OrgStage: _.map(
            _.filter(this.$refs.orgStage.searchList, {
              checked: true,
            }),
            "name"
          ),
          OrgIndustry: _.map(
            _.filter(this.$refs.orgIndustry.searchList, {
              checked: true,
            }),
            "name"
          ),
        };
        var checkOrgStageAll = _.find(
          this.$refs.orgStage.searchList,
          function (key) {
            return key.name == "全部";
          }
        );
        if (checkOrgStageAll && checkOrgStageAll.checked) {
          searchParams.OrgStage = [];
        }
        var checkorgIndustryAll = _.find(
          this.$refs.orgIndustry.searchList,
          function (key) {
            return key.name == "全部";
          }
        );
        if (checkorgIndustryAll && checkorgIndustryAll.checked) {
          searchParams.OrgIndustry = [];
        }
      }
      //查询-机构关系
      if (this.type == common.searchTypeEnum.contractor) {
        searchParams = {
          // TitleIds: _.map(
          //   _.filter(this.$refs.title.searchList, {
          //     checked: true,
          //   }),
          //   "name"
          // ),
          RelationDeepthIds: _.map(
            _.filter(this.$refs.relationDeepth.searchList, {
              checked: true,
            }),
            "id"
          ),
          UserIndustrys: _.map(
            _.filter(this.$refs.userIndustry.searchList, {
              checked: true,
            }),
            "name"
          ),
        };
        // var checkTitleAll = _.find(
        //   this.$refs.title.searchList,
        //   function (key) {
        //     return key.name == "全部";
        //   }
        // );
        // if (checkTitleAll && checkTitleAll.checked) {
        //   searchParams.TitleIds = [];
        // }
        //关系深度
        var checkrelationAll = _.find(
          this.$refs.relationDeepth.searchList,
          function (key) {
            return key.name == "全部";
          }
        );
        if (checkrelationAll && checkrelationAll.checked) {
          searchParams.RelationDeepthIds = [];
        }
        //专注行业
        var checkUserIndustryAll = _.find(
          this.$refs.userIndustry.searchList,
          function (key) {
            return key.name == "全部";
          }
        );
        if (checkUserIndustryAll && checkUserIndustryAll.checked) {
          searchParams.UserIndustrys = [];
        }
      }
      //查询-公司关系
      if (this.type == common.searchTypeEnum.contractorCompany) {
        searchParams = {
          RelationDeepthIds: _.map(
            _.filter(this.$refs.relationCompanyDeepth.searchList, {
              checked: true,
            }),
            "id"
          ),
        };
        //关系深度
        var checkrelationAll = _.find(
          this.$refs.relationCompanyDeepth.searchList,
          function (key) {
            return key.name == "全部";
          }
        );
        if (checkrelationAll && checkrelationAll.checked) {
          searchParams.RelationDeepthIds = [];
        }
      }
      //查询-公司
      if (this.type == common.searchTypeEnum.invested) {
        searchParams = {
          InvestmentRoundIds: _.map(
            _.filter(this.$refs.companyRound.searchList, {
              checked: true,
            }),
            "code"
          ),
          IndustryNames: _.map(
            _.filter(this.$refs.companyIndustry.searchList, {
              checked: true,
            }),
            "name"
          ),
          InvestmentDate: null,
        };
        let first = _.find(
          this.$refs.companyInvestmentDate.searchList,
          {
            checked: true,
          }
        );
        if (first) {
          searchParams.InvestmentDate = first.code;
        }
        var checkinvestmentRoundAll = _.find(
          this.$refs.companyRound.searchList,
          function (key) {
            return key.name == "全部";
          }
        );
        if (
          checkinvestmentRoundAll &&
          checkinvestmentRoundAll.checked
        ) {
          searchParams.InvestmentRoundIds = [];
        }
        var checkindustryNameAll = _.find(
          this.$refs.companyIndustry.searchList,
          function (key) {
            return key.name == "全部";
          }
        );
        if (checkindustryNameAll && checkindustryNameAll.checked) {
          searchParams.IndustryNames = [];
        }
      }
      if (this.type == common.searchTypeEnum.orgInvestedCompany) {
        searchParams = {
          IndustryNames: _.map(
            _.filter(
              this.$refs.companyIndustryByOrgInvestedCompany
                .searchList,
              {
                checked: true,
              }
            ),
            "name"
          ),
        };
        var checkindustryNameAll = _.find(
          this.$refs.companyIndustryByOrgInvestedCompany.searchList,
          function (key) {
            return key.name == "全部";
          }
        );
        if (checkindustryNameAll && checkindustryNameAll.checked) {
          searchParams.IndustryNames = [];
        }
      }
      if (this.type == common.searchTypeEnum.newsType) {
        searchParams = {
          newsTypeString: _.map(
            _.filter(this.$refs.news.searchList, {
              checked: true,
            }),
            "name"
          ),
          searchPeriod: _.map(
            _.filter(this.$refs.newsPeriod.searchList, {
              checked: true,
            }),
            "code"
          ),
        };
        var checkNews = _.find(
          this.$refs.news.searchList,
          function (key) {
            return key.name == "全部";
          }
        );
        if (checkNews && checkNews.checked) {
          searchParams.newsTypeString = [];
        }
      }
      if (this.type == common.searchTypeEnum.marketPeriod) {
        searchParams = {
          searchPeriod: _.map(
            _.filter(this.$refs.marketNews.searchList, {
              checked: true,
            }),
            "code"
          ),
        };
        var checkmarketNews = _.find(
          this.$refs.marketNews.searchList,
          function (key) {
            return key.name == "全部";
          }
        );
        if (checkmarketNews && checkmarketNews.checked) {
          searchParams.searchPeriod = [];
        }
      }

      if (this.type == common.searchTypeEnum.exitIPO) {
        searchParams = {
          orgIndustry: _.map(
            _.filter(this.$refs.orgIndustryIPO.searchList, {
              checked: true,
            }),
            "name"
          )
        };
        var checkorgIndustrylist = _.find(
          this.$refs.orgIndustryIPO.searchList,
          function (key) {
            return key.name == "全部";
          }
        );
        if (checkorgIndustrylist && checkorgIndustrylist.checked) {
          searchParams.orgIndustry = [];
        }
      }

      if (this.type == common.searchTypeEnum.exitIPO2) {

        searchParams = {
          stockExchanges: _.map(
            _.filter(this.$refs.stockExchange.searchList, {
              checked: true,
            }),
            "id"
          ),
        };


        var checkstockExchangeslist = _.find(
          this.$refs.stockExchange.searchList,
          function (key) {
            return key.name == "全部";
          }
        );
        if (
          checkstockExchangeslist &&
          checkstockExchangeslist.checked
        ) {
          searchParams.stockExchanges = [];
        }
      }

      if (this.type == common.searchTypeEnum.exitSales) {
        searchParams = {
          orgIndustry: _.map(
            _.filter(this.$refs.orgIndustrySales.searchList, {
              checked: true,
            }),
            "name"
          ),
        };
        var checkorgIndustrylist = _.find(
          this.$refs.orgIndustrySales.searchList,
          function (key) {
            return key.name == "全部";
          }
        );
        if (checkorgIndustrylist && checkorgIndustrylist.checked) {
          searchParams.orgIndustry = [];
        }
      }


      if (this.type == common.searchTypeEnum.orgListFunding1) {

        searchParams = {
          InvestmentDate: null,
        };
        let first = _.find(this.$refs.fund_dates.searchList, {
          checked: true,
        });
        if (first) {
          searchParams.InvestmentDate = first.code;
        }
      }

      if (this.type == common.searchTypeEnum.orgListFunding2) {

        searchParams = {

          OrgIndustry: _.map(
            _.filter(this.$refs.fund_orgIndustry.searchList, {
              checked: true,
            }),
            "name"
          )
        };

        var checkorgIndustryAll = _.find(
          this.$refs.fund_orgIndustry.searchList,
          function (key) {
            return key.name == "全部";
          }
        );
        if (checkorgIndustryAll && checkorgIndustryAll.checked) {
          searchParams.OrgIndustry = [];
        }

      }
      if (this.type == common.searchTypeEnum.orgListFunding3) {

        searchParams = {
          OrgStage: _.map(
            _.filter(this.$refs.fund_orgStage.searchList, {
              checked: true,
            }),
            "code"
          )
        };

        var checkOrgStageAll = _.find(
          this.$refs.fund_orgStage.searchList,
          function (key) {
            return key.name == "全部";
          }
        );
        if (checkOrgStageAll && checkOrgStageAll.checked) {
          searchParams.OrgStage = [];
        }
      }

      if (this.type == common.searchTypeEnum.onlyDates) {
        searchParams = {
          InvestmentDate: null,
        };
        let first = _.find(this.$refs.onlyDates.searchList, {
          checked: true,
        });
        if (first) {
          searchParams.InvestmentDate = first.code;
        }
      }
      if (isReset) {
        searchParams.hasFilter = false;
      } else {
        searchParams.hasFilter = true;;
      }
      this.$emit("search", searchParams);
      this.resetStoreItem();
    },
    reset () {
      if (this.type == common.searchTypeEnum.org) {
        this.$refs.orgStage.reset();
        this.$refs.orgIndustry.reset();
      }
      if (this.type == common.searchTypeEnum.contractor) {
        this.$refs.title.reset();
        this.$refs.relationDeepth.reset();
        this.$refs.userIndustry.reset();
      }
      if (this.type == common.searchTypeEnum.contractorCompany) {
        this.$refs.relationCompanyDeepth.reset();
      }
      if (this.type == common.searchTypeEnum.invested) {
        this.$refs.companyIndustry.reset();
        this.$refs.companyRound.reset();
        this.$refs.companyInvestmentDate.reset();
      }
      if (this.type == common.searchTypeEnum.orgInvestedCompany) {
        this.$refs.companyIndustryByOrgInvestedCompany.reset();
      }
      if (this.type == common.searchTypeEnum.newsType) {
        this.$refs.news.reset();
        this.$refs.newsPeriod.reset();
      }
      if (this.type == common.searchTypeEnum.marketPeriod) {
        this.$refs.marketNews.reset();
      }
      if (this.type == common.searchTypeEnum.exitIPO) {
        this.$refs.orgIndustryIPO.reset();
      } else if (this.type == common.searchTypeEnum.exitIPO2) {
        this.$refs.stockExchange.reset();
      }

      else if (this.type == common.searchTypeEnum.exitSales) {
        this.$refs.orgIndustrySales.reset();
      } else if (this.type == common.searchTypeEnum.orgListFunding1) {
        this.$refs.fund_dates.reset();
      } else if (this.type == common.searchTypeEnum.orgListFunding2) {

        this.$refs.fund_orgIndustry.reset();
      }
      else if (this.type == common.searchTypeEnum.orgListFunding3) {
        this.$refs.fund_orgStage.reset();

      }
      else if (this.type == common.searchTypeEnum.onlyDates) {
        this.$refs.onlyDates.reset();
      }
      setTimeout(() => {
        this.search(true);
      }, 200);
    },
    initSelectItem (isOrg) {
      if (this.type == common.searchTypeEnum.org) {
        this.$refs.orgStage.initSelectItem();
        this.$refs.orgIndustry.initSelectItem(isOrg);
      }
      if (this.type == common.searchTypeEnum.invested) {
        this.$refs.companyIndustry.initSelectItem(isOrg);
        this.$refs.companyRound.initSelectItem();
        this.$refs.companyInvestmentDate.initSelectItem();
      }
    },
    resetStoreItem () {
      if (this.type == common.searchTypeEnum.org) {
        storejs.state.orgStage = null;
        storejs.state.orgIndustry = null;
      }
      if (this.type == common.searchTypeEnum.invested) {
        storejs.state.companyIndustry = null;
        storejs.state.companyRound = null;
        storejs.state.companyInvestmentDate = null;
      }
    },
    resetPanel () {
      if (this.type == common.searchTypeEnum.org) {
        this.$refs.orgStage.reset();
        this.$refs.orgIndustry.reset();
      }
      if (this.type == common.searchTypeEnum.invested) {
        this.$refs.companyIndustry.reset();
        this.$refs.companyRound.reset();
        this.$refs.companyInvestmentDate.reset();
      }
    }
  },
};
</script>


<style lang="scss" scoped>
.title {
  padding: 1rem 1rem 0 1rem;
  font-size: 18px;
  font-weight: 600;
}
.search-type {
  padding: 1rem;
  flex: 1;
}
.reset-button {
  width: 50%;
}
.ok-button {
  width: 50%;
  background-color: #c52a1a;
  color: white;
}
.panle-content {
  height: calc(100% - 44px);
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/common/SearchPanel.vue